export * from '@radix-ui/react-tabs';
